module.exports = __webpack_public_path__ + "img/serviceUser.21b24de9.png";